export const SELECTOR_LENGTH = 10;
